import React, { useState } from 'react';
import { X, RotateCcw, AlertTriangle } from 'lucide-react';
import CustomLoader from '../../../shared/components/ui/CustomLoader';
import { restorePptVersion } from '../utils/pptVersionService';
import { extractApiError } from '../utils/apiErrorUtils';
import './PptVersionModals.css';

const RestoreVersionModal = ({ rfpId, version, onClose, onSuccess }) => {
    const [restoring, setRestoring] = useState(false);
    const [error, setError] = useState('');

    const handleRestore = async () => {
        setRestoring(true);
        setError('');
        try {
            const result = await restorePptVersion(rfpId, version.version_number);
            onSuccess(result?.new_version_number);
        } catch (err) {
            console.error('Restore error:', err);
            if (err.response?.status === 403) {
                setError("You don't have permission to restore this version.");
            } else {
                setError(extractApiError(err, 'Restore failed. Please try again.'));
            }
        } finally {
            setRestoring(false);
        }
    };

    return (
        <div className="pvm-overlay" onClick={onClose}>
            <div className="pvm-modal pvm-modal-sm" onClick={(e) => e.stopPropagation()}>
                <div className="pvm-header">
                    <div className="pvm-header-icon pvm-icon-warning">
                        <AlertTriangle size={20} color="#F59E0B" />
                    </div>
                    <div>
                        <h3>Restore Version {version.version_number}?</h3>
                        <p>This will replace the current PPT layout with Version {version.version_number}. Your current layout will be saved as a new version.</p>
                    </div>
                    <button className="pvm-close-btn" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                {error && <div className="pvm-error">{error}</div>}

                <div className="pvm-footer pvm-footer-space-between">
                    <button className="pvm-btn-outline" onClick={onClose} disabled={restoring}>
                        Cancel
                    </button>
                    <button className="pvm-btn-danger" onClick={handleRestore} disabled={restoring}>
                        {restoring ? <CustomLoader size={14} color="white" /> : <RotateCcw size={14} />}
                        <span>Restore Version {version.version_number}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RestoreVersionModal;
